import { apiClient } from './api';

export type ProfileResponse = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: string;
  supplierId: number | null;
  supplierName: string | null;
};

export type UpdateProfilePayload = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  currentPassword?: string;
  newPassword?: string;
};

export const profileService = {
  getProfile: () => apiClient.get<ProfileResponse>('/profile'),

  updateProfile: (payload: UpdateProfilePayload) =>
    apiClient.put<ProfileResponse, UpdateProfilePayload>('/profile', payload),
};
